/**
 * Section: Matériel fleuriste — carousel produits
 */

(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.mflBound === '1') return;

    var track = root.querySelector('[data-mfl-track]');
    var prev = root.querySelector('[data-mfl-prev]');
    var next = root.querySelector('[data-mfl-next]');
    var slides = root.querySelectorAll('[data-mfl-product]');

    if (!track || !slides.length) return;

    function visibleWidth() {
      return track.clientWidth * 0.92;
    }

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function updateNav() {
      if (!prev || !next) return;
      var max = maxScroll();
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= max - 4 || max <= 4;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -visibleWidth(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: visibleWidth(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);

    root.dataset.mflBound = '1';
    updateNav();
  }

  function run(scope) {
    var roots = (scope || document).querySelectorAll('[data-mfl-section]');
    roots.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) run(e.target);
  });
})();
